import React, { useState } from 'react'
import PropTypes from 'prop-types'

import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import MenuItem from '@material-ui/core/MenuItem'
import TextField from '@material-ui/core/TextField'

import httpService from '@services/httpService'

const options = () => [
  { id: '', name: '—' },
  { id: 'sale', name: I18n.t('v4/equipment.acquisition_types.sale') },
  { id: 'commodate', name: I18n.t('v4/equipment.acquisition_types.commodate') }
]

const AcquisitionTypeDialog = ({ open, onCancel, asset, updateUrl, successUrl }) => {
  const [sensorType, setSensorType] = useState((asset && asset.acquisition_type) || '')
  const [boosterType, setBoosterType] = useState((asset && asset.booster_acquisition_type) || '')

  const save = () => {
    httpService
      // Ambos os campos vão sempre no payload: a operação só altera o que
      // recebe, então omitir um deles preservaria o valor anterior em vez de
      // aplicar o que está na tela.
      .put(`${updateUrl}.json`, {
        acquisition_type: sensorType,
        booster_acquisition_type: boosterType
      })
      .then(() => Turbolinks.visit(successUrl))
      .catch((e) => console.error('boom!', e))
  }

  const select = (label, value, onChange, testId) => (
    <TextField
      select
      fullWidth
      margin='normal'
      variant='outlined'
      InputLabelProps={{ shrink: true }}
      label={label}
      value={value}
      onChange={(event) => onChange(event.target.value)}
      inputProps={{ 'data-testid': testId }}
    >
      {options().map((option) => (
        <MenuItem key={option.id} value={option.id}>{option.name}</MenuItem>
      ))}
    </TextField>
  )

  return (
    <Dialog open={open} onClose={onCancel} fullWidth maxWidth='xs'>
      <DialogTitle>{I18n.t('v4/organization_asset.acquisition_dialog.title')}</DialogTitle>

      <DialogContent>
        <DialogContentText>
          {asset ? asset.name : ''}
        </DialogContentText>

        {select(
          I18n.t('v4/organization_asset.acquisition_dialog.sensor'),
          sensorType,
          setSensorType,
          'acquisition-type-select'
        )}

        {select(
          I18n.t('v4/organization_asset.acquisition_dialog.booster'),
          boosterType,
          setBoosterType,
          'booster-acquisition-type-select'
        )}

        <DialogContentText variant='caption'>
          {I18n.t('v4/organization_asset.acquisition_dialog.booster_hint')}
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button variant='outlined' onClick={onCancel}>
          {I18n.t('v4/delete_dialog.cancel')}
        </Button>

        <Button color='primary' variant='contained' onClick={save} data-testid='save-acquisition-type'>
          {I18n.t('v4/organization_asset.acquisition_dialog.save')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

AcquisitionTypeDialog.propTypes = {
  open: PropTypes.bool,
  onCancel: PropTypes.func,
  asset: PropTypes.object,
  updateUrl: PropTypes.string,
  successUrl: PropTypes.string
}

export default AcquisitionTypeDialog
